import React, { useState, useEffect } from "react";
import {
    FaHistory, FaCheckCircle, FaHourglassHalf, FaCalendarAlt,
    FaCommentAlt, FaTools, FaArrowLeft, FaChevronRight, FaChevronLeft
} from "react-icons/fa";

const PublicComplaintsList = ({ establishmentId, public_request }) => {
    const [complaints, setComplaints] = useState([]);
    const [loading, setLoading] = useState(true);

    // إعدادات الترقيم الصفحي
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize] = useState(20);
    const [totalPages, setTotalPages] = useState(1);

    useEffect(() => {
        const fetchComplaints = async () => {
            setLoading(true);
            try {
                // إرسال المعايير بناءً على توثيق الـ API (Swagger)
                const response = await public_request.get(`/public/complaints/public`, {
                    params: {
                        page: currentPage,
                        pageSize: pageSize
                    }
                });
                console.log(response);
                // تحديث البيانات بناءً على هيكلة الرد من السيرفر
                setComplaints(response.data.complaints || []);

                // حساب إجمالي الصفحات (تأكد من مسمى totalCount في الـ API لديك)
                if (response.data.totalCount) {
                    setTotalPages(Math.ceil(response.data.totalCount / pageSize));
                }
            } catch (error) {
                console.error("Error fetching public complaints:", error);
            } finally {
                setLoading(false);
            }
        };

        if (establishmentId) fetchComplaints();
    }, [establishmentId, currentPage, pageSize]);
    // }, [establishmentId,public_request, currentPage, pageSize]);

    const handlePageChange = (newPage) => {
        setCurrentPage(newPage);
        // التمرير لأعلى قسم الشكاوى عند تغيير الصفحة
        document.querySelector('.complaints-section')?.scrollIntoView({ behavior: 'smooth' });
    };

    if (loading && complaints.length === 0) {
        return (
            <div className="text-center p-5">
                <div className="spinner-border text-info spinner-border-sm"></div>
                <p className="mt-2 text-muted small">جاري تحميل سجل الشكاوى...</p>
            </div>
        );
    }

    if (!loading && complaints.length === 0) return null;

    return (
        <div className="complaints-section mt-5 animate-fade-in">
            {/* الهيدر */}
            <div className="section-header-modern mb-4">
                <div className="header-icon-box"><FaHistory /></div>
                <div>
                    <h4 className="mb-0 fw-bold">سجل الشكاوى المعالجة</h4>
                    <p className="text-muted small mb-0">عرض الشكاوى العامة والإجراءات المتخذة حيالها</p>
                </div>
            </div>

            {/* قائمة الشكاوى */}
            <div className="row g-4">
                {complaints.map((c) => (
                    <div key={c.complaintUid} className="col-md-6">
                        <div className={`modern-complaint-card ${c.staffResponse ? 'processed' : 'pending'}`}>

                            {/* البار العلوي للكارد */}
                            <div className="card-top-bar">
                                <span className="status-label">
                                    {c.staffResponse ? <><FaCheckCircle /> شكوى معالجة</> : <><FaHourglassHalf /> قيد الدراسة</>}
                                </span>
                                <div className="date-badge">
                                    <FaCalendarAlt className="ms-1" />
                                    {new Date(c.createdAtUtc).toLocaleDateString('ar-SY')}
                                </div>
                            </div>

                            {/* محتوى الشكوى التفصيلي */}
                            <div className="complaint-content">
                                <div className="content-label">
                                    <FaCommentAlt className="ms-2" /> نص الشكوى
                                </div>
                                <p className="complaint-text">{c.complaintText}</p>
                            </div>

                            {/* قسم الرد (يظهر فقط إذا وجد رد) */}
                            {c.staffResponse && (
                                <div className="response-section">
                                    <div className="response-connector"><FaArrowLeft /></div>
                                    <div className="response-body">
                                        <div className="d-flex justify-content-between align-items-center mb-2">
                                            <div className="content-label text-success m-0">
                                                <FaTools className="ms-2" /> الإجراء المتخذ
                                            </div>
                                            <small className="update-date">
                                                تم الرد في {new Date(c.updatedAtUtc || c.createdAtUtc).toLocaleDateString('ar-SY')}
                                            </small>
                                        </div>
                                        <p className="response-text">{c.staffResponse}</p>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                ))}
            </div>

            {/* أزرار التنقل (Pagination) */}
            {totalPages > 1 && (
                <div className="pagination-wrapper mt-5 d-flex justify-content-center align-items-center gap-3">
                    <button
                        className="btn-pagination-modern"
                        disabled={currentPage === 1 || loading}
                        onClick={() => handlePageChange(currentPage - 1)}
                    >
                        <FaChevronRight /> السابق
                    </button>

                    <div className="page-indicator">
                        الجمعة <span>{currentPage}</span> من <span>{totalPages}</span>
                    </div>

                    <button
                        className="btn-pagination-modern"
                        disabled={currentPage === totalPages || loading}
                        onClick={() => handlePageChange(currentPage + 1)}
                    >
                        التالي <FaChevronLeft />
                    </button>
                </div>
            )}

            <style>{`
                .animate-fade-in { animation: fadeIn 0.5s ease-in; }
                @keyframes fadeIn { from { opacity: 0; transform: translateY(10px); } to { opacity: 1; transform: translateY(0); } }

                .section-header-modern { display: flex; align-items: center; gap: 15px; padding-bottom: 20px; }
                .header-icon-box { width: 45px; height: 45px; background: rgba(56, 189, 248, 0.1); color: #38bdf8; border-radius: 12px; display: flex; align-items: center; justify-content: center; font-size: 1.2rem; }

                .modern-complaint-card { background: #1e293b; border-radius: 20px; padding: 20px; height: 100%; border: 1px solid rgba(255,255,255,0.05); transition: all 0.3s ease; position: relative; }
                .modern-complaint-card:hover { border-color: rgba(56, 189, 248, 0.3); box-shadow: 0 10px 30px rgba(0,0,0,0.2); }
                
                .card-top-bar { display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px; }
                .status-label { font-size: 0.8rem; font-weight: 700; padding: 5px 12px; border-radius: 8px; display: flex; align-items: center; gap: 5px; }
                .pending .status-label { background: rgba(245, 158, 11, 0.1); color: #f59e0b; }
                .processed .status-label { background: rgba(16, 185, 129, 0.1); color: #10b981; }

                .date-badge { font-size: 0.75rem; color: #94a3b8; background: rgba(255,255,255,0.03); padding: 5px 10px; border-radius: 8px; }

                .content-label { font-size: 0.85rem; font-weight: 700; color: #38bdf8; margin-bottom: 10px; display: flex; align-items: center; }
                .complaint-text { color: #e2e8f0; font-size: 0.95rem; line-height: 1.6; padding-right: 10px; border-right: 2px solid rgba(56, 189, 248, 0.2); margin-right: 5px; }

                .response-section { margin-top: 20px; position: relative; padding-top: 15px; border-top: 1px dashed rgba(255,255,255,0.1); }
                .response-connector { position: absolute; top: -12px; left: 50%; transform: translateX(-50%) rotate(-90deg); background: #1e293b; color: #10b981; font-size: 0.8rem; padding: 0 5px; }
                .response-body { background: rgba(16, 185, 129, 0.05); padding: 15px; border-radius: 12px; border: 1px solid rgba(16, 185, 129, 0.1); }
                .response-text { color: #cbd5e1; font-size: 0.9rem; line-height: 1.5; margin: 0; }
                .update-date { font-size: 0.7rem; color: #64748b; }

                /* ستايل الترقيم */
                .btn-pagination-modern {
                    background: #1e293b;
                    color: #38bdf8;
                    border: 1px solid rgba(56, 189, 248, 0.2);
                    padding: 10px 20px;
                    border-radius: 12px;
                    font-weight: 600;
                    display: flex;
                    align-items: center;
                    gap: 10px;
                    transition: all 0.2s;
                }
                .btn-pagination-modern:hover:not(:disabled) {
                    background: #38bdf8;
                    color: white;
                    transform: scale(1.05);
                }
                .btn-pagination-modern:disabled { opacity: 0.3; cursor: not-allowed; }
                .page-indicator { color: #94a3b8; font-size: 0.9rem; }
                .page-indicator span { color: #38bdf8; font-weight: bold; margin: 0 4px; }
            `}</style>
        </div>
    );
};

export default PublicComplaintsList;